import React from 'react';
import { Spring } from 'react-spring';

import Project from './Project';

/* eslint-disable camelcase */

import headspace_png from './images/headspace/headspace_logo.png';
import headspace_png_2x from './images/headspace/headspace_logo@2x.png';
import headspace_png_3x from './images/headspace/headspace_logo@3x.png';
import headspace_webp from './images/headspace/headspace_logo.webp';

import w3w_png from './images/w3w/w3w_logo.png';
import w3w_png_2x from './images/w3w/w3w_logo@2x.png';
import w3w_png_3x from './images/w3w/w3w_logo@3x.png';
import w3w_webp from './images/w3w/w3w_logo.webp';

import stickeryo_png from './images/stickeryo/stickeryo_logo.png';
import stickeryo_png_2x from './images/stickeryo/stickeryo_logo@2x.png';
import stickeryo_png_3x from './images/stickeryo/stickeryo_logo@3x.png';
import stickeryo_webp from './images/stickeryo/stickeryo_logo.webp';

import styles from './style.css';

const projects = [
  {
    name: 'Headspace',
    description:
      'Meditation from $0 to $250M dollars valuation. We built the first and second version of the app.',
    links: {
      appleStore:
        'https://itunes.apple.com/us/app/headspace-meditation/id493145008?mt=8',
      googlePlay:
        'https://play.google.com/store/apps/details?id=com.getsomeheadspace.android&hl=en'
    },
    style: {
      background: '#E8FF6B'
    },
    delay: 580,
    logo: {
      png: `${headspace_png} 1x, ${headspace_png_2x} 2x, ${headspace_png_3x} 3x`,
      webp: headspace_webp,
      fallback: headspace_png
    },
    className: styles.headspace
  },
  {
    name: 'What3Words',
    description:
      'Inventing the addressing system for the entire world is not easy, we did it. This is a game changer.',
    links: {
      appleStore: 'https://itunes.apple.com/ro/app/what3words/id657878530?mt=8',
      googlePlay:
        'https://play.google.com/store/apps/details?id=com.what3words.android'
    },
    style: {
      background: '#FFC554'
    },
    delay: 760,
    logo: {
      png: `${w3w_png} 1x, ${w3w_png_2x} 2x, ${w3w_png_3x} 3x`,
      webp: w3w_webp,
      fallback: w3w_png
    },
    className: styles.w3w
  },
  {
    name: 'Sticker YO!',
    description:
      'Creativity goes beyond code, we deliver high customer delight through mouthwatering illustrations.',
    links: {
      appleStore:
        'https://itunes.apple.com/us/app/sticker-yo/id1152448530?mt=8',
      googlePlay: ''
    },
    style: {
      background: '#A1FFDF'
    },
    delay: 666,
    logo: {
      png: `${stickeryo_png} 1x, ${stickeryo_png_2x} 2x, ${stickeryo_png_3x} 3x`,
      webp: stickeryo_webp,
      fallback: stickeryo_png
    },
    className: styles.stickeryo
  }
];

/* eslint-enable camelcase */

const Projects = () => (
  <div className={styles.projects}>
    {projects.map(({ style: { background }, delay, ...project }) => (
      <Spring
        key={project.name}
        delay={delay}
        native
        from={{ transform: 'translate3d(0, 100vh, 0)' }}
        to={{ transform: 'translate3d(0, 0vh, 0)' }}
      >
        {computedStyle => (
          <Project {...project} background={background} style={computedStyle} />
        )}
      </Spring>
    ))}
  </div>
);

export default Projects;
